import React, { useState } from 'react'
import styles from './InstrumentsWrrapper.module.css'
import { direction } from './../../store/direction'
import { useEffect } from 'react'

export default function InstrumentsWrrapper({ leftHead = 'left', rightHead = 'right', leftIcon, rightIcon, leftChilds, rightChilds }) {
	const [selHead, setSelLebel] = useState('left')

	const handleSelectHead = head => {
		direction.newLeftOrRight(head)
		setSelLebel(head)
	}

	const classLeftHead = selHead == 'left' ? styles.active_left : ''
	const classRightHead = selHead == 'right' ? styles.active_right : ''
	useEffect(() => {
		return () => {
			handleSelectHead('left')
		}
	}, [])
	return (
		<div className={styles.InstrumentsWrrapper}>
			<div className={styles.MenuWrapper}>
				<h3 className={classLeftHead} onClick={handleSelectHead.bind(null, 'left')}>
					{leftIcon} {leftHead}{' '}
				</h3>
				<h3 className={classRightHead} onClick={handleSelectHead.bind(null, 'right')}>
					{rightIcon} {rightHead}{' '}
				</h3>
			</div>
			<div className={styles.instruments}>{selHead == 'left' ? leftChilds : rightChilds}</div>
		</div>
	)
}
